import {BreadCrumbs} from "../../../components/open/pages";
import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ThinAddIcon, ThinTrashIcon} from "../../../components/icons/material-icons";
import {AdminsAddEditNewsModal} from "./add-edit-news";
import {CurrencyFormat} from "../../../components/techaran/money";
import {Link, useNavigate} from "react-router-dom";
import {RemoveModal} from "../../../components/template/remove-modal";
import {ShowSnackbar} from "../../../components/template/snackbar";

interface newsInterface {
    id: number,
    title: string,
    img: string,
    category: string,
    createdAt: string,
    signupCount: number,
}

export const AdminNewsScreen = () => {
    const [list, setList] = useState<newsInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        title: '',
    });
    const [canAdd,setCanAdd] = useState(false);
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/news/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: newsInterface[] | null,
                canAdd:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== "OK") {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
                setCanAdd(d.canAdd);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "اطلاعیه ها | اتوماسیون";
        fetchList();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'اطلاعیه‌ها', url: '/admins/news'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>اطلاعیه‌ها</b>
                                {
                                    canAdd ?
                                        <button onClick={() => setAddModal(true)}>
                                            <ThinAddIcon/>
                                            <span>اطلاعیه جدید</span>
                                        </button> : null
                                }
                            </div>
                            <table className="table open-table table-striped table-hover table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>عنوان</th>
                                    <th>دسته‌بندی</th>
                                    <th>تعداد ثبت‌نام</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    list.map((s, i) =>
                                        <tr key={"QQs39ruWsj2239" + i}>
                                            <td>{CurrencyFormat(i + 1)}</td>
                                            <td>
                                                <Link to={`/admins/news/view/${s.id}`}>
                                                    {s.title}
                                                </Link>
                                            </td>
                                            <td>{s.category}</td>
                                            <td>{CurrencyFormat(s.signupCount)} نفر</td>
                                            <td>
                                                {
                                                    canAdd ?
                                                        <button className="open-tooltip" onClick={() => setRemoveModal({
                                                            title: s.title,
                                                            show: true,
                                                            id: s.id,
                                                        })}>
                                                            <i>حذف</i>
                                                            <ThinTrashIcon/>
                                                        </button> : '-'
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsAddEditNewsModal
                active={addModal}
                closeHandler={() => setAddModal(false)}
                isEdit={false}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
                newsId={'0'}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                title={"حذف اطلاعیه"}
                desc={`آیا مطمئن هستید می‌خواهید اطلاعیه ${removeModal.title} را حذف کنید؟`}
                onRemove={() => {
                    ShowProgressLoading();
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/news/remove',
                        {
                            id: x.id,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string | undefined,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'اطلاعیه حذف گردید.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};